import React from 'react'

export const ALL_WIDGETS = [
  {
    label: 'میلگرد',
    value: 'milgerd',
    Component: React.lazy(() => import('./Milgerd')),
  },
  {
    label: 'نبشی',
    value: 'nabshi',
    Component: React.lazy(() => import('./Nabshi')),
  },
  {
    label: 'تسمه',
    value: 'tasmeh',
    Component: React.lazy(() => import('./Tasmeh')),
  },
  {
    label: 'پروفیل',
    value: 'profil',
    Component: React.lazy(() => import('./Profil')),
  },
  {
    label: 'ورق',
    value: 'varagh',
    Component: React.lazy(() => import('./Varagh')),
  },
  {
    label: 'ورق برش خورده',
    Component: React.lazy(() => import('./VaraghBoreshKhorde')),
    value: 'varaghBoreshKhorde',
  },
  {
    label: 'لوله',
    Component: React.lazy(() => import('./Loole')),
    value: 'loole',
  },
  {
    label: 'آلمینیوم لوله',
    Component: React.lazy(() => import('./AluminiumLoole')),
    value: 'aluminiumLoole',
  },
  {
    label: 'آلمینیوم نبشی',
    value: 'aluminiumNabshi',
    Component: React.lazy(() => import('./AluminiumNabshi')),
  },
  {
    label: 'پروفیل آلمینیوم',
    value: 'aluminiumProf',
    Component: React.lazy(() => import('./AluminiumProf')),
  },
  {
    label: 'شفت آلمینیوم',
    value: 'aluminiumShaft',
    Component: React.lazy(() => import('./AluminiumShaft')),
  },
  {
    label: 'ورق آلمینیوم',
    value: 'aluminiumVaragh',
    Component: React.lazy(() => import('./AluminiumVaragh')),
  },
  {
    label: 'چهار پهلو',
    Component: React.lazy(() => import('./Charpahlo')),
    value: 'charpahlo',
  },
  {
    label: 'گریتینگ گالونیزه',
    value: 'gratingTasme',
    Component: React.lazy(() => import('./GratingTasme')),
  },
  {
    label: 'میلگرد استیل',
    value: 'steelMilgerd',
    Component: React.lazy(() => import('./SteelMilgerd')),
  },
  {
    label: 'میلگرد استنلس استیل',
    value: 'steelMaftool',
    Component: React.lazy(() => import('./SteelMilgerd')),
  },
  {
    label: 'نبشی استنلس استیل',
    value: 'steelNabshi',
    Component: React.lazy(() => import('./SteelNabshi')),
  },
  {
    label: 'پروفیل استنلس استیل صنعتی',
    value: 'steelProfSanati',
    Component: React.lazy(() => import('./SteelProf')),
  },
  {
    label: 'پروفیل استنلس استیل دکوراتیو',
    value: 'steelProfDecorative',
    Component: React.lazy(() => import('./SteelProf')),
  },
  {
    label: 'پروفیل استنلس استیل صنایع غذایی',
    value: 'steelProf',
    Component: React.lazy(() => import('./SteelProf')),
  },
  {
    label: ' ورق استنلس استیل صنعتی',
    value: 'steelVaraghSanati',
    Component: React.lazy(() => import('./SteelVaragh')),
  },
  {
    label: ' ورق استنلس استیل دکوراتیو',
    value: 'steelVaraghDecorative',
    Component: React.lazy(() => import('./SteelVaragh')),
  },
  {
    label: ' حصاری/پرسی',
    Component: React.lazy(() => import('./Toori')),
    value: 'toori',
  },
  {
    label: 'استیل لوله صنعتی',
    Component: React.lazy(() => import('./SteelLoole')),
    value: 'steelLoole',
  },
  {
    label: 'استیل لوله دکوراتیو',
    Component: React.lazy(() => import('./SteelLoole')),
    value: 'steelLooleDecorative',
  },
  {
    label: 'استیل لوله غذایی',
    Component: React.lazy(() => import('./SteelLoole')),
    value: 'steelLooleGhazaei',
  },
  {
    label: 'پولکی ',
    Component: React.lazy(() => import('./Poolaki')),
    value: 'poolaki',
  },
  {
    label: 'آلمینیوم سپری',
    value: 'aluminiumSepari',
    Component: React.lazy(() => import('./AluminiumSepari')),
  },
]

type Props = {
  selectedProductType?: string
}

export const RenderWidget = ({ selectedProductType }: Props) => {
  const foundedWidget = ALL_WIDGETS.find(
    (item) => item.value === selectedProductType
  )

  return foundedWidget?.Component ? (
    <foundedWidget.Component name={foundedWidget.value} />
  ) : null
}
